import React from 'react';
import './check-sign.scss';
import { Tooltip } from '@ru-digital-assets/ui-component';
import { Placement } from '@ru-digital-assets/ui-component/dist/stories/tooltip';
import InfoLabel from '../InfoLabel';

interface ICheckSign {
  tooltipPlacement?: Placement;
}

export default function CheckSign({ tooltipPlacement }: ICheckSign) {
  return (
    <Tooltip
      title={
        <p>
          Вы можете проверить подпись документа на сайте{' '}
          <a
            href="https://crypto.kontur.ru/verify"
            target="_blank"
            rel="noreferrer"
          >
            crypto.kontur.ru
          </a>
        </p>
      }
      placement={tooltipPlacement || 'top-start'}
      isCloseClick
    >
      <div className="check-sign">
        <InfoLabel text="Как проверить подпись" />
      </div>
    </Tooltip>
  );
}
